import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetPrintInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintInvoice?` + params, null);

export const GetPrintCreditNoteReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintCreditNote?` + params, null);

export const GetPrintDebitNoteReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintDebitNote?` + params, null);

export const GetDeliveryChallanReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetDeliveryChallanReport?` + params, null);

export const GetPrintInvoiceReportDownload = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintInvoice?` + params, null);

export const GetAreawiseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/AreawiseReport?` + params, null);


export const GetDailySaleReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DailySaleReport?` + params, null);

export const GetDailyPurchaseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DailyPurchaseReport?` + params, null);

export const GetDailyStaffSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StaffSummaryReport?` + params, null);

export const GetDailyGSTReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DailyGSTReport?` + params, null);

export const GetGSTR1Report = (params: any) =>
     get(`${BASE_URL}/api/Report/GSTR1Report?` + params, null);

export const GetPurchaseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PurchaseReport?` + params, null);

export const GetPurchaseOrderReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PurchaseOrderReport?` + params, null);

export const GetSaleReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleReport?` + params, null);

export const GetCreditNoteReport = (params: any) =>
     get(`${BASE_URL}/api/Report/CreditNoteReport?` + params, null);

export const GetDebitNoteReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DebitNoteReport?` + params, null);

export const GetChallanReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ChallanReport?` + params, null);

export const GetSaleRegister = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleRegister?` + params, null);

export const GetPurchaseRegister = (params: any) =>
     get(`${BASE_URL}/api/Report/PurchaseRegister?` + params, null);

export const GetCreditRegisterReport = (params: any) =>
     get(`${BASE_URL}/api/Report/CreditRegister?` + params, null);

export const GetDebitRegisterReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DebitRegister?` + params, null);

export const GetCustomerLedger = (params: any) =>
     get(`${BASE_URL}/api/Report/CustomerLedger?` + params, null);

export const GetOutstandingReceivableReport = (params: any) =>
     get(`${BASE_URL}/api/Report/OutstandingReceivableReport?` + params, null);

export const GetOutstandingReceivableSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/OutstandingReceivableSummaryReport?` + params, null);

export const GetOutstandingPayableSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/OutstandingPayableSummaryReport?` + params, null);

export const GetOutstandingReceivableReportNEW = (data: any) =>
     post(`${BASE_URL}/api/Report/OutstandingReceivableReportNew`, data).then((body: any) => ({ data: body }));

export const GetSupplierLeddger = (params: any) =>
     get(`${BASE_URL}/api/Report/SupplierLeddger?` + params, null);

export const GetOutStandingPayableReport = (params: any) =>
     get(`${BASE_URL}/api/Report/OutStandingPayableReport?` + params, null);

export const GetOutStandingPayableReportNew = (data: any) =>
     post(`${BASE_URL}/api/Report/OutStandingPayableReportNew`, data).then((body: any) => ({ data: body }));

export const GetStaffReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StaffReport?` + params, null);

export const GetBuyerReport = (params: any) =>
    get(`${BASE_URL}/api/Report/BuyerReport?` + params, null);

export const GetStockAdjReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StockAdjReport?` + params, null);

export const GetProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ProductReport?` + params, null);

export const GetTaxReport = (params: any) =>
     get(`${BASE_URL}/api/Report/TaxReport?` + params, null);

export const GetUnitReport = (params: any) =>
     get(`${BASE_URL}/api/Report/UnitReport?` + params, null);

export const GetFirmReport = (params: any) =>
     get(`${BASE_URL}/api/Report/FirmReport?` + params, null);

export const GetBranchReport = (params: any) =>
     get(`${BASE_URL}/api/Report/BranchReport?` + params, null);

export const GetSupplierReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SupplierReport?` + params, null);

export const GetStockReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StockReport?` + params, null);

// export const GetPrintProformaInvoiceReport = (params: any) =>
//      get(`${BASE_URL}/api/Report/GetPrintProformaInvoice?` + params, null);

export const GetPrintProformaInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintProformaLandScape?` + params, null);

export const GetPrintQuotationInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintQuotationLandScape?` + params, null);

export const GetPrintQuotationLWHInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintQuotationLWHInvoiceReport?` + params, null);

export const GetPrintLabourInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintLabourInvoice?` + params, null);

export const GetProformaReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ProformaReport?` + params, null);

export const GetQuotationReport = (params: any) =>
     get(`${BASE_URL}/api/Report/QuotationReport?` + params, null);

export const GetLabourReport = (params: any) =>
     get(`${BASE_URL}/api/Report/LabourReport?` + params, null);

export const GetPaymentReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PaymentReport?` + params, null);

export const GetPrintPaymentReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintPayment?` + params, null);

export const GetPrintCashPaymentVoucher = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintCashPaymentVoucher?` + params, null);

export const GetPrintJournalVoucher = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintJournalVoucher?` + params, null);

export const GetInvoiceReceiptReport = (params: any) =>
     get(`${BASE_URL}/api/Report/InvoiceReceiptReport?` + params, null);

export const GetPrintInvoiceReceiptReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintInvoiceReceipt?` + params, null);

export const GetJEReceiptReport = (params: any) =>
     get(`${BASE_URL}/api/Report/JEReceiptReport?` + params, null);

export const GetJEContraReport = (params: any) =>
     get(`${BASE_URL}/api/Report/JEContraReport?` + params, null);

export const GetJEPaymentReport = (params: any) =>
     get(`${BASE_URL}/api/Report/JEPaymentReport?` + params, null);

export const GetJEJournalVoucherReport = (params: any) =>
     get(`${BASE_URL}/api/Report/JEJournalVoucherReport?` + params, null);

// export const GetJournalVoucherReport = (params: any) =>
//      get(`${BASE_URL}/api/Report/JournalVoucherReport?` + params, null);

export const GetStockStatementReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StockStatementReport?` + params, null);

export const GetLandScapePrintInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintInvoiceLandScape?` + params, null);

export const GetPrintInvoiceHtml = (params: any) =>
     get(`${BASE_URL}/api/Report/GetTaxInvoiceHtml?` + params, null);

export const GetTaxInvoiceHtmlWithRightSideLogo = (params: any) =>
     get(`${BASE_URL}/api/Report/GetTaxInvoiceHtmlWithRightSideLogo?` + params, null);

export const GetLandScapePrintStockAdjReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPrintStockAdj?` + params, null);


export const GetLWHPrintInvoiceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PrintInvoiceLWH?` + params, null);

export const GetCategoryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/CategoryReport?` + params, null);

export const GetExpenseCategoryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenceCategoryReport?` + params, null);

export const GetExpenseItemReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenseItemReport?` + params, null);

export const GetTransporterReport = (params: any) =>
     get(`${BASE_URL}/api/Report/TransporterReport?` + params, null);

export const GetWarehouseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/WarehouseReport?` + params, null);

export const GetLedgerSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/Getgroupsummaryreport?` + params, null);

export const GetLedgerMonthlySummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/Getmonthlysummaryreport?` + params, null);

export const GetLedgerVoucherReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLedgervoucherreport?` + params, null);

export const GetBalanceSheetReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetBalanceSheetReport?` + params, null);

export const GetDayBookReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetDayBookReport?` + params, null);

export const GetProfitAndLossReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetProfitAndLossReport?` + params, null);

export const GetTrialBalanceReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetTrialBalanceReport?` + params, null);

export const GetPurchaseReturnReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PurchaseReturnReport?` + params, null);

export const GetSaleReturnReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleReturnReport?` + params, null);

export const GetEWayBillDriverCopy = (params: any) =>
     get(`${BASE_URL}/api/Report/EWayBillDriverCopy?` + params, null);

export const GetEWayBillOriginalCopy = (params: any) =>
     get(`${BASE_URL}/api/Report/EWayBillOriginalCopy?` + params, null);

export const GetLedgerVoucherForAreawiseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLedgerVoucherForAreaReport?` + params, null);

export const GetStockSummaryBySupplier = (params: any) =>
     get(`${BASE_URL}/api/Report/StockSummaryBySupplier?` + params, null);

export const GetStockSummaryByBuyer = (params: any) =>
     get(`${BASE_URL}/api/Report/StockSummaryByBuyer?` + params, null);

export const GetStockDetailsByBuyer = (params: any) =>
     get(`${BASE_URL}/api/Report/StockDetailsByBuyer?` + params, null);

export const GetStockSummaryByProductAndBuyer = (params: any) =>
     get(`${BASE_URL}/api/Report/StockSummaryByProductAndBuyer?` + params, null);

export const GetFreeGoodsDetailByBuyer = (params: any) =>
     get(`${BASE_URL}/api/Report/FreeGoodsDetailByBuyer?` + params, null);

export const GetFreeGoodsSummaryByBuyer = (params: any) =>
     get(`${BASE_URL}/api/Report/FreeGoodsSummaryByBuyer?` + params, null);

export const GetFreeGoodsSummaryByCategory = (params: any) =>
     get(`${BASE_URL}/api/Report/FreeGoodsSummaryByCategory?` + params, null);

export const GetQuotationDetailDataReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetQuotationDetailDataReport?` + params, null);

export const GetPurchaseDetailDataReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseDetailDataReport?` + params, null);

export const GetGSTR2Report = (params: any) =>
     get(`${BASE_URL}/api/Report/GSTR2Report?` + params, null);

export const GetGSTR3BReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GSTR3BReport?` + params, null);

export const GetPrintLedgerList = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLedgerReport?` + params, null);

export const GetStockBatchWiseListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/StockBatchWiseListReport?` + params, null);


export const GetStockExpiredListRerport = (params: any) =>
     get(`${BASE_URL}/api/Report/StockExpiredListRerport?` + params, null);


export const GetNearExpiryListRerport = (params: any) =>
     get(`${BASE_URL}/api/Report/NearExpiryListRerport?` + params, null);


export const GetLowQuantityListRerport = (params: any) =>
     get(`${BASE_URL}/api/Report/LowQuantityListRerport?` + params, null);


export const GetSaleSummaryBySalePersonReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetSaleSummaryBySalePersonReport?` + params, null);

export const GetSaleSummaryByCustomerReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetSaleSummaryByCustomerReport?` + params, null);


export const GetSaleDetailsByCustomerWiseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetSaleDetailsByCustomerWiseReport?` + params, null);


export const GetSaleSummaryByProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetSaleSummaryByProductReport?` + params, null);

export const GetSaleDetailsByProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetSaleDetailsByProductReport?` + params, null);

export const GetPurchaseSummaryBySupplierReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseSummaryBySupplierReport?` + params, null);

export const GetPurchaseDetailsBySupplierReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseDetailsBySupplierReport?` + params, null);

export const GetPurchaseSummaryByProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseSummaryByProductReport?` + params, null)

export const GetPurchaseDetailsByProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseDetailsByProductReport?` + params, null);

export const GetStockWarehouseByReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetStockWarehouseWiseReport?` + params, null);

export const GetStockCategoryByReport = (params: any) =>
   get(`${BASE_URL}/api/Report/GetStockCategoryWiseReport?` + params, null);


export const GetCashBookPartyWiseListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetCashbookPartyWiseReport?` + params, null);

export const GetPurchaseAnalysisSummaryDataListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseAnalysisSummaryDataListReport?` + params, null);

export const GetLedgerGroupSummaryAdvance = (params: any) =>
     get(`${BASE_URL}/api/Report/LedgerGroupSummaryAdvanceReport?` + params, null);

export const GetDocumentReport = (params: any) =>
     get(`${BASE_URL}/api/Report/DocumentListReport?` + params, null);

export const GetStockTransferByIdReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetStockTransferByIdReport?` + params, null);

export const GetExpenseVehicleReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenseVehicle?` + params, null);

export const GetExpenseCategoryWiseReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenseCategory?` + params, null);

export const GetExpenseLedgerAccountReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenseLedgerAccount?` + params, null);

export const GetExpenseVoucherListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/ExpenseVoucherList?` + params, null);

export const GetIncomeVoucherListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/IncomeVoucherList?` + params, null);

export const GetLRSummaryByVehicleReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLRSummaryByVehicleReport?` + params, null);

export const GetLRSummaryByVehicleListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLRSummaryByVehicleListReport?` + params, null);

export const GetLRMonthlySummaryByVehicleListReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetLRMonthlySummaryByVehicleListReport?` + params, null);
export const GetStockTransferSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetStockTransferSummary?` + params, null);

export const GetSaleExportToTally = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleExportToTally?` + params, null);

export const GetChallanExportToTally = (params: any) =>
     get(`${BASE_URL}/api/Report/GetChallanExportToTally?` + params, null);

export const GetFromToAddressExportToTally = (params: any) =>
     get(`${BASE_URL}/api/Report/FromToAddressExportToTally?` + params, null);

export const GetInvoiceDispatchSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/InvoiceDispatchSummaryReport?` + params, null);

export const GetProductExportToTally = (params: any) =>
     get(`${BASE_URL}/api/Report/ProductExportToTally?` + params, null);

export const GetSaleOrderDueSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleOrderDueSummary?` + params, null);

export const GetLedgerGroupSummaryDetailReport = (params: any) =>
     get(`${BASE_URL}/api/Report/LedgerGroupSummaryDetail?` + params, null);

export const GetSaleOrderDueDetailReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleOrderDueDetail?` + params, null);

export const GetPurchaseOrderDueSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseOrderDueSummaryReport?` + params, null);

export const GetPurchaseOrderDueDetailReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetPurchaseOrderDueDetailReport?` + params, null);

export const GetChallanDueSummaryReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetChallanDueSummaryReport?` + params, null);

export const GetChallanDueDetailReport = (params: any) =>
     get(`${BASE_URL}/api/Report/GetChallanDueDetailReport?` + params, null);

export const GetPossibleBOMCountByAvailableStockReport = (params: any) =>
     get(`${BASE_URL}/api/Report/PossibleBOMCountByAvailableStock?` + params, null);

export const GeneratePrintInvoiceEWayBill = (params: any) =>
     get(`${BASE_URL}/api/Report/GeneratePrintInvoiceEWayBill?` + params, null);

export const GetSaleSummaryByCustomerAndProductReport = (params: any) =>
     get(`${BASE_URL}/api/Report/SaleSummaryByCustomerAndProduct?` + params, null);

export const GetLabelLevelPartyBalance = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Report/LabelLevelPartyBalance?` + params, null);

export const GetStockLedgerReport = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Report/stockledgerreport?` + params, null);

export const GetActiveBuyerByInvoiceDurationReport = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Report/GetActiveBuyerByInvoiceDurationReport?` + params, null);


